<template>
  <VContainer class="private-uk-pension-page">
    <VRow>
      <VCol cols="12">
        <div class="private-uk-pension-page__content">
          <p>
            XtraPension partners with two different regulated financial firms to help you with your old UK Work /
            Private pension. Please contact them directly and mention XtraPension!
          </p>
          <table class="table-border">
            <tbody>
              <tr>
                <td>
                  <div>
                    <b>For People in Ireland</b>
                  </div>
                  <div class="mt-3">
                    <a href="https://erinvestments.ie/" target="_blank">www.ERinvestments.ie</a>
                  </div>
                  <div class="mt-3">
                    Pat Surlis <br />
                    Director
                  </div>
                  <div class="mt-3">
                    <a href="mailto:pat@eripro.ie" target="_blank">pat@eripro.ie</a><br />
                    Tel: 085 856 9066
                  </div>
                  <div class="mt-3">
                    Unit 15, 3rd Floor, Ross House, <br />
                    Merchants Road, Galway
                  </div>
                </td>
                <td>
                  <div>
                    <b>For People OUTSIDE Ireland</b>
                  </div>
                  <div class="mt-3">
                    <a href="https://chasebuchanan.com/" target="_blank">www.ChaseBuchanan.ie</a>
                  </div>
                  <div class="mt-3">
                    Malcolm McDowell <br />
                    Private Wealth Manager
                  </div>
                  <div class="mt-3">
                    <a href="mailto:malcolm.mcdowell@chasebuchanan.com" target="_blank"
                      >malcolm.mcdowell@chasebuchanan.com</a
                    ><br />
                    Tel: +44 (0) 7551 291 096
                  </div>
                  <div class="mt-3">9 Global Offices</div>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table-border">
            <tbody>
              <tr>
                <td>
                  <div>
                    <b>Why Move Your Old Private UK Pension?</b>
                  </div>
                  <ul class="mt-3">
                    <li>Access Funds from Age 55</li>
                    <li>Easier to Manage & Access</li>
                    <li>Avoid Currency Risks</li>
                    <li>Avoid Tax Penalties</li>
                    <li>
                      The regulatory changes since Brexit affect members of UK pension schemes based internationally.
                    </li>
                    <li>
                      It may be possible to reduce income tax when passing your pensions to your partner or spouse after
                      death.
                    </li>
                  </ul>
                </td>
                <td>
                  <div>
                    <b>Both Partners Offer:</b>
                  </div>
                  <ul class="mt-3">
                    <li>Free Initial Assessment Call - To discuss your pension, needs/timelines and options</li>
                    <li>Guidance - Step-by-Step guidance on transferring your old private UK pension</li>
                    <li>Tax Issues – We steer you clear of the many pitfalls.</li>
                    <li>Manage the Transfer - Some UK Providers are just difficult. We can help.</li>
                    <li>Investment Advice - We can also offer advice re your Private Irish Pension(s)</li>
                    <li>Financial Planning - From debt reduction to investing, we do it all.</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </VCol>
    </VRow>
  </VContainer>
</template>
<script>
import { mapActions } from 'vuex';
// Utils
export default {
  name: 'PrivateUkPensionPage',
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    ...mapActions('main', ['showSnackbar'])
  }
};
</script>
